export default __webpack_public_path__ + "static/media/histroy_outline_icon.5ad3811b.svg";